import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { CaracteristicaProdutoConsorcioModel } from "../models/caracteristica-produto-consorcio.model";

@Injectable()
export class CaracteristicaProdutoConsorcioService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Caracteristica Produto Consórcio por id
     * @param id ID da Caracteristica Produto Consórcio
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "consorcio/caracteristica-produto/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Caracteristica Produto Consórcio
     * @param id ID da Caracteristica Produto Consórcio
     */
    getAll(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "consorcio/caracteristica-produto" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Caracteristica Produto Consórcio
     * @param id ID da Caracteristica Produto Consórcio
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "consorcio/caracteristica-produto/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Caracteristica Produto Consórcio
     * @param id ID da Caracteristica Produto Consórcio
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "consorcio/caracteristica-produto/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Caracteristica Produto Consórcio
     * @param params Json Caracteristica Produto Consórcio
     */
    create(params: any): Observable<any> {
        return this._http.post(
            this.utilitesService.urlPrefix + "consorcio/caracteristica-produto",
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Atualiza Caracteristica Produto Consórcio
     * @param params Json Caracteristica Produto Consórcio
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "consorcio/caracteristica-produto/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista
     */
    getLista(params: any): Observable<ApiPaginationResponseDataNonNullable<CaracteristicaProdutoConsorcioModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }
        return this._http.get<ApiPaginationResponseDataNonNullable<CaracteristicaProdutoConsorcioModel>>(
            this.utilitesService.urlPrefix + "consorcio/caracteristica-produto/lista" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }
}
